var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 470",
    d: "M0 0h29v29H0z",
    style: {
      fill: "none"
    },
    transform: "translate(1 4)"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 471",
    d: "M30.9 20.355a11.983 11.983 0 0 0 .1-1.6 9.785 9.785 0 0 0-.12-1.6l3.478-2.692a.832.832 0 0 0 .206-1.039l-3.29-5.656a.839.839 0 0 0-1.011-.375l-4.1 1.635a12.121 12.121 0 0 0-2.776-1.6L22.774 3.1a.828.828 0 0 0-.822-.7h-6.58a.81.81 0 0 0-.805.7l-.617 4.325a12.388 12.388 0 0 0-2.776 1.6l-4.1-1.635a.82.82 0 0 0-1.011.375L2.8 13.422a.772.772 0 0 0 .2 1.039l3.48 2.692a9.424 9.424 0 0 0-.034 3.2l-3.479 2.694a.832.832 0 0 0-.206 1.039l3.29 5.656a.839.839 0 0 0 1.011.375l4.1-1.635a12.121 12.121 0 0 0 2.776 1.6l.617 4.327a.841.841 0 0 0 .822.7h6.58a.8.8 0 0 0 .805-.7l.617-4.327a11.769 11.769 0 0 0 2.776-1.6l4.1 1.635a.82.82 0 0 0 1.011-.375l3.29-5.656a.786.786 0 0 0-.206-1.039zm-12.238 4.532a6.133 6.133 0 1 1 6.168-6.133 6.169 6.169 0 0 1-6.168 6.133z",
    transform: "translate(-2.662 -2.4)",
    style: {
      fill: "current"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.bbd1c155c5ba8cfafd74af1a04866850.svg";
export { ForwardRef as ReactComponent };